module.exports = __webpack_public_path__ + "img/2821c56.png";